import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface InputProps extends IconButtonProps {
  icon: React.ReactNode;
}

export const RoundButton = (props: IconButtonProps) => {
  return (
    <IconButton
      {...props}
      classes={{
        root: clsx(styles.root, {
          [styles.disabled]: props.disabled,
        }),
      }}
    >
      {props.children}
    </IconButton>
  );
};
